const TipoDeDoc = {
    DNI: "DNI",
    PASSPORT: "PASS",
    PERMISO_TEMP_PERM: "PTP",
    CARNET_EXT: "CE",
};

const TipoDeCliente = {
    DocId: "DocId",
    RUC: "RUC",
};

const Sexo = {
    Masculino: "M",
    Femenino: "F",
    SinDef: "",
};

export {TipoDeDoc, TipoDeCliente, Sexo };
